import { useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import { Typography } from "@mui/material";
import { importOrders } from "../../../../../../../services/orders.services";
import CircularLoader from "../../../../../../../Components/CircularLoader/CircularLoader";
import { generateOrderExcelTemp } from "./generateOrderExcelTemp";
import { useSelector } from "react-redux";

export default function ImportModal({ open, setOpen, setSnack, setRefresh }) {
  const [loading, setLoading] = useState(false);

  const [selectedFile, setSelectedFile] = useState(null);

  const user = useSelector((state) => state.user);
  const warehouses = user?.user_approved_warehouses;

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  const handleUpload = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("file", selectedFile);

    const response = await importOrders(formData);
    if (!response.error) {
      setRefresh(Math.floor(Math.random() * 100) + 1);
      setLoading(false);
      handleClose();
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: response.data.message,
          severity: "success",
        };
      });
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: "Something went wrong",
          severity: "error",
        };
      });
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedFile(null);
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="absolute top-1/2 left-1/2 w-full max-w-md transform -translate-x-1/2 -translate-y-1/2 bg-ui-surface p-6 rounded-xl shadow-lg">
          <div className="text-xl font-semibold text-center mb-6">
            Import Excel Data Of Order's
          </div>

          <div className="mb-6">
            <div className="mb-4 text-center">
              <p className="text-sm text-ui-text-muted text-center mb-2">
                Fill out the provided Excel template and upload it here.
              </p>
              <button
                onClick={() => generateOrderExcelTemp(warehouses)}
                className="px-3 py-1 bg-state-success text-white text-sm rounded hover:bg-state-success transition"
              >
                Download Template
              </button>
            </div>
            <div className="flex flex-col gap-4">
              <div className="min-w-[120px]">
                <label
                  htmlFor="file-upload"
                  className="flex flex-col items-center p-5 border-2 border-dashed border-indigo-600 rounded-md bg-ui-surface-sunken cursor-pointer"
                >
                  <input
                    id="file-upload"
                    type="file"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    className="hidden"
                    onChange={handleFileChange}
                  />

                  <Typography
                    variant="h6"
                    color="primary"
                    component="div"
                    className="cursor-pointer"
                  >
                    Click to Upload Excel File
                  </Typography>

                  {selectedFile && (
                    <Typography
                      variant="body1"
                      className="mt-2 text-sm text-ui-text"
                    >
                      {selectedFile.name}
                    </Typography>
                  )}
                </label>
              </div>
            </div>
          </div>

          <div className="flex justify-end gap-4">
            <button
              className={`px-4 py-2 rounded-md border border-ui-border text-ui-text hover:bg-ui-surface-sunken transition ${
                loading ? "opacity-50 cursor-not-allowed" : ""
              }`}
              onClick={handleClose}
              disabled={loading}
            >
              Cancel
            </button>

            <button
              className={`px-4 py-2 rounded-md bg-brand text-white hover:bg-brand-hover transition ${
                selectedFile === null || loading
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
              onClick={handleUpload}
              disabled={selectedFile === null || loading}
            >
              {loading ? <CircularLoader /> : "Save"}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
